import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toast = () => {
    return <ToastContainer theme='dark' newestOnTop limit={3} />;
};

export default Toast;
